import { render, staticRenderFns } from "./PaymentMethodChoice.vue?vue&type=template&id=88e50122"
import script from "./PaymentMethodChoice.vue?vue&type=script&lang=js"
export * from "./PaymentMethodChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports